<template>
  <BaseModal :id="`modalDelete__${section.id}`" title="Delete this section" size="lg">
    <p class="text-dark small">Are you sure that you want to delete this section?</p>
    <b-alert show class="d-flex align-items-center pl-2 align-content-center" variant="danger">
      <span>
        <strong class="d-block ml-3">
          {{ titleTime.start_at }} {{ titleTime.city_timezone }} time -
          {{ titleTime.end_at }}
          {{ titleTime.city_timezone }} time
        </strong>
      </span>
    </b-alert>
    <p class="text-dark small">Click at the "Delete" button to delete this section.</p>
    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click="hide()"> Cancel </b-button>
      <b-button variant="danger" @click="handleDelete()">
        <span v-if="!isLoading">Delete</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin';
import Section from '@/models/Section';
import BaseModal from '@/components/base-components/BaseModal';

export default {
  name: 'ModalDeleteSection',

  components: { BaseModal },

  mixins: [notificationMixin],

  props: {
    section: {
      type: Object,
      default: null
    },
    titleTime: {
      type: Object,
      required: true,
      default: () => ({
        start_at: null,
        end_at: null,
        city_timezone: 'Bangkok'
      })
    },
    index: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    show() {
      this.$bvModal.show(`modalDelete__${this.section.id}`);
    },
    hide() {
      this.$bvModal.hide(`modalDelete__${this.section.id}`);
    },
    async handleDelete() {
      try {
        this.isLoading = true;
        await Section.api().deleteSection(this.section.id);
        Section.delete(this.section.id);

        this.hide();
        this.notiSuccess('section', 'deleted');
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
        this.notiError();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
